import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

/** Elige cómo registrar una comida antes de abrir el formulario detallado. */
export const MealLogDialog = ({ open, onOpenChange, meal, onPlanned, onOther, onSkip, busy }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="rounded-3xl sm:max-w-sm" data-testid="meal-log-dialog">
      <DialogHeader>
        <DialogTitle className="font-display text-xl">Registrar {meal?.label?.toLowerCase() || "comida"}</DialogTitle>
        <DialogDescription>
          Planificado: «{meal?.name}». Indica si comiste eso u otra cosa.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-2">
        <button
          type="button"
          disabled={busy}
          onClick={onPlanned}
          data-testid="meal-log-planned"
          className="w-full rounded-full bg-food py-3 font-semibold text-white transition-transform active:scale-95 disabled:opacity-60"
        >
          Comí el plan
        </button>
        <button
          type="button"
          disabled={busy}
          onClick={onOther}
          data-testid="meal-log-other"
          className="w-full rounded-full border-2 border-food bg-white py-3 font-semibold text-food-ink transition-transform active:scale-95 disabled:opacity-60"
        >
          Comí otra cosa
        </button>
        <button
          type="button"
          disabled={busy}
          onClick={onSkip}
          data-testid="meal-log-skip"
          className="w-full rounded-full py-2.5 text-sm font-semibold text-stone-500 hover:bg-stone-100"
        >
          No la hice
        </button>
      </div>
    </DialogContent>
  </Dialog>
);
